// Single source of truth for year-group + term values used across admin
// dropdowns (Invoices filters, New invoice form, Schedules form, Email
// composer, etc.). Change the list here and every consumer picks it up.
//
// Stored format matches what parent/student profile forms write: "Year N".
// Use `shortYear()` to render the compact "Yr N" form for inline displays.

export const YEAR_GROUP_OPTIONS = [
    'Year 4',
    'Year 5',
    'Year 6',
    'Year 7',
    'Year 8',
    'Year 9',
    'Year 10',
    'Year 11',
    'Year 12',
    'Year 13',
];

export const TERM_OPTIONS = ['Term 1', 'Term 2', 'Term 3'];

export const shortYear = (y) => (y ? String(y).replace(/^Year\s+/i, 'Yr ') : '');
